// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"7457c0c3","513":"54f810b7"}[chunkId] + ".chunk.js";
};